module.exports = __webpack_public_path__ + "static/media/s2.58cdfd06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s2.jpg
// module id = 111
// module chunks = 0